import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';

import config from './Panel.component.config';

import './Panel.less';

export class Panel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: this.props.visible,
      swipeableViewsProps: false,
    };
  }

  componentDidUpdate = prevProps => {
    // unpullable panel should set show state immediately after props visible changes
    if (prevProps.visible !== this.props.visible && !this.props.pullable) {
      this._updateShowState(this.props.visible);
    }
  };

  _updateShowState = show => {
    this.setState({
      show,
    });
  };

  _onSwipePanel = show => {
    this.setState({ show });
    if (this.props.onChange)
      this.props.onChange(!!this.props.overflowHeight, show);
  };

  _onClickMask = () => {
    if (this.props.onChange) this.props.onChange(false);
  };

  _toggleSwipeable = swipeableViewsProps => () => {
    this.setState({ swipeableViewsProps });
  };

  render() {
    const {
      visible,
      children,
      overflowHeight,
      pullable,
      swipeableViewsProps,
    } = this.props;
    const panelMaskClass = this.state.show ? 'panel-mask hidden' : 'panel-mask';

    if (visible) {
      return (
        <div className="modal-panel">
          <div className={panelMaskClass} onClick={this._onClickMask} />
          <SwipeableBottomSheet
            open={this.state.show}
            overflowHeight={overflowHeight}
            bodyStyle={{ borderRadius: '1.2rem 1.2rem 0rem 0rem' }}
            onChange={this._onSwipePanel}
            swipeableViewsProps={{
              disabled: !(
                swipeableViewsProps || this.state.swipeableViewsProps
              ),
            }}
          >
            <div
              className="bottom-sheet"
              style={{ minHeight: overflowHeight ? '100vh' : 0 }}
            >
              <div className="bottom-sheet-body">
                {pullable && (
                  <div
                    className="bottom-sheet-swipearea"
                    onTouchStart={this._toggleSwipeable(true)}
                    onTouchEnd={this._toggleSwipeable(false)}
                  >
                    <div className="bottom-sheet-line" />
                  </div>
                )}
                <div className="bottom-sheet-content">{children}</div>
              </div>
            </div>
          </SwipeableBottomSheet>
        </div>
      );
    }

    return null;
  }
}

Panel.displayName = config.displayName;
Panel.propTypes = config.propTypes;
Panel.defaultProps = config.defaultProps;

export default injectIntl(Panel);
